import { PilotId } from '~/eds/src/types/PilotId';

/**
 * Coerces a persisted `user_id` value into a `PilotId`. Numeric strings are
 * parsed to numbers; a non-numeric value is returned as-is (defensive — stored
 * ids are expected to be numeric). Empty or nullish values map to `null`.
 *
 * Shared by the USER READ component and the questionInputRegistry value mappers
 * so both paths coerce identically.
 */
export const toUserId = (value: unknown): PilotId | null => {
  if (value == null || value === '') return null;
  const num = Number(value);
  return Number.isNaN(num) ? (value as PilotId) : num;
};

/** Normalizes a USER field value (single, multi, or empty) into `PilotId[]`. */
export const toValueUserIds = (value: unknown): PilotId[] => {
  if (value == null) return [];
  const raw = Array.isArray(value) ? value : [value];
  return raw
    .map((id) => toUserId(id))
    .filter((id): id is PilotId => id != null);
};

/** Normalize UF field values (single or multi) into user ids. */
export const collectUserIdsFromFieldValues = (
  values: Array<{ value?: unknown }>,
): PilotId[] => values.flatMap((entry) => toValueUserIds(entry.value));
